<template>
<div>
	<Card :title="title||'订单基本信息'">
        <Form :label-width="120" class="mt15">
			<Row>
				<Col span="12">
					<FormItem label="批单状态：">
						{{ info.statusName }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="批单号：">
						<span class="lineFeed">{{ info.billNo }}</span>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="批单创建时间：">
						{{ info.createTime }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="批单确认时间：">
						{{ info.updateTime }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="保障凭证号：">
						<a :href="'#/my/customizedTPL/policyDetail/'+(info.policyNo)" target="_blank" rel="opener" class="lineFeed">{{ info.policyNo }}</a>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="投保公司：">
						{{ info.centerName }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="联系方式：">
						{{ info.phone }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="被保公司：">
						{{ info.companyListString }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="保单号：">
						{{ info.policyScrip }}
					</FormItem>
				</Col>
				<Col span="24" v-if="info.attachmentUrl">
					<FormItem label="批改单：">
						<div v-for="(item,index) in imgList" :key="index" style="word-wrap:break-word; word-break:break-all;">
							{{ item }}
							<a :href="item" target="_blank" rel="opener" class="ml15">查看</a>
						</div>
					</FormItem>
				</Col>
				<Col span="24">
					<FormItem label="审核备注：">
						{{ info.auditRemark }}
					</FormItem>
				</Col>
			</Row>
		</Form>
    </Card>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		title:String,
		type:{
			type:String,
			default(){
				return 'order'
			}
		},
	},
	computed:{
		imgList(){
			return this.info.attachmentUrl?this.info.attachmentUrl.split(','):[]
		}
	},
	methods:{
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift/common/riderBasicInfo.vue